const dateFormatter = (str: string): string => {
  const c = str.replaceAll(/\s+/g, '').split(' ').join('');
  return c.substring(0, c.length - 1);
};

export default dateFormatter;
